module.exports = __webpack_public_path__ + "img/hiring.f54426e2.jpg";